module.exports = __webpack_public_path__ + "img/publish-loading-icon.3cc268e2.png";